import src from '../assets/thelinksclub.png';
import { imageLogo } from './imageLogo';

/**
 * The Links Club — full-color circular badge (sky + fairway with flag & club
 * head; opaque white ground, as delivered). Reused as the tenant's icon in
 * TENANT_ICON_MAP. Was a base64 data URI; now a 24KB quantized asset.
 */
export const TheLinksClubLogo = imageLogo({
  src,
  width: 1000,
  height: 1000,
  alt: 'The Links Club',
});
